import * as React from 'react'
import { Defs, LinearGradient, Path, Stop } from 'react-native-svg'
import styled from 'styled-components/native'

import { AccessibleSvg } from 'ui/svg/AccessibleSvg'
import { AccessibleIcon } from 'ui/svg/icons/types'
import { svgIdentifier } from 'ui/svg/utils'

function BicolorNoIdSvg({
  size,
  color,
  color2,
  accessibilityLabel,
  testID,
  opacity,
}: AccessibleIcon): React.JSX.Element {
  const { id, fill } = svgIdentifier()

  return (
    <AccessibleSvg
      width={size}
      height={size}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      viewBox="0 0 48 48"
      fill={fill}>
      <Defs>
        <LinearGradient id={id} x1="28.841%" x2="71.159%" y1="0%" y2="100%">
          <Stop offset="0%" stopColor={color} />
          <Stop offset="100%" stopColor={color2} />
        </LinearGradient>
      </Defs>
      <Path
        opacity={opacity}
        d="M1.86679 6.77399C1.43935 6.42426 1.37635 5.79424 1.72607 5.36679C2.0758 4.93935 2.70582 4.87635 3.13327 5.22607L4.63827 6.45744C5.19408 6.16525 5.82745 6 6.50006 6H42.5001C44.7123 6 46.5001 7.78772 46.5001 10V38C46.5001 38.805 46.2634 39.5538 45.8556 40.1807L47.1333 41.2261C47.5607 41.5758 47.6237 42.2058 47.274 42.6333C46.9243 43.0607 46.2942 43.1237 45.8668 42.774L1.86679 6.77399ZM44.2886 38.8986C44.4239 38.6287 44.5001 38.3235 44.5001 38V10C44.5001 8.89228 43.6078 8 42.5001 8H6.52362L12.9058 13.2217C13.7612 12.2792 14.9976 11.6899 16.37 11.6899C18.9487 11.6899 21.05 13.7741 21.05 16.3599V18.9799C21.05 19.2679 21.0239 19.5497 20.9741 19.8231L44.2886 38.8986ZM19.05 18.2489V16.3599C19.05 14.8858 17.8513 13.6899 16.37 13.6899C15.6196 13.6899 14.9426 13.9954 14.4571 14.4911L19.05 18.2489ZM2.50006 11.7467C2.50006 11.1944 2.94778 10.7467 3.50006 10.7467C4.05235 10.7467 4.50006 11.1944 4.50006 11.7467V38C4.50006 39.1077 5.39235 40 6.50006 40H36.5001C37.0523 40 37.5001 40.4477 37.5001 41C37.5001 41.5523 37.0523 42 36.5001 42H6.50006C4.28778 42 2.50006 40.2123 2.50006 38V11.7467ZM13.3232 17.9656C12.6703 17.4314 11.69 17.896 11.69 18.7396V18.9799C11.69 21.5658 13.7913 23.6499 16.37 23.6499C16.906 23.6499 17.4213 23.5599 17.9014 23.3941C18.5819 23.159 18.6112 22.2922 18.054 21.8362C17.7245 21.5667 17.2718 21.5309 16.8529 21.6067C16.6963 21.6351 16.5349 21.6499 16.37 21.6499C14.8887 21.6499 13.69 20.4541 13.69 18.9799V18.7396C13.69 18.4397 13.5554 18.1556 13.3232 17.9656ZM42.693 41.9954C42.6291 41.9985 42.5648 42 42.5001 42H42.6986L42.693 41.9954ZM7.27317 32.1048C8.33575 28.0782 11.9934 25.1 16.3701 25.1C20.7467 25.1 24.4044 28.0782 25.467 32.1048C25.554 32.4347 25.4669 32.7863 25.2358 33.0373C24.6041 33.7234 23.8853 34.3444 23.1101 34.8684C22.6526 35.1777 22.0309 35.0576 21.7216 34.6C21.4123 34.1425 21.5325 33.5209 21.99 33.2115C22.4802 32.8802 22.9451 32.5008 23.372 32.0858C22.3684 29.1848 19.619 27.1 16.3701 27.1C13.1213 27.1 10.3719 29.1846 9.36825 32.0854C11.1815 33.8469 13.6471 34.94 16.3701 34.94C17.1746 34.94 17.9548 34.8485 18.6931 34.6685C19.2297 34.5376 19.7707 34.8665 19.9016 35.403C20.0325 35.9396 19.7036 36.4806 19.167 36.6115C18.2654 36.8314 17.3256 36.94 16.3701 36.94C12.8553 36.94 9.70353 35.4215 7.50501 33.038C7.27344 32.7869 7.18602 32.4351 7.27317 32.1048ZM27.5001 14C27.5001 13.4477 27.9478 13 28.5001 13H39.5001C40.0523 13 40.5001 13.4477 40.5001 14C40.5001 14.5523 40.0523 15 39.5001 15H28.5001C27.9478 15 27.5001 14.5523 27.5001 14ZM28.5001 19C27.9478 19 27.5001 19.4477 27.5001 20C27.5001 20.5523 27.9478 21 28.5001 21H36.5001C37.0523 21 37.5001 20.5523 37.5001 20C37.5001 19.4477 37.0523 19 36.5001 19H28.5001Z"
      />
    </AccessibleSvg>
  )
}

export const BicolorNoId = styled(BicolorNoIdSvg).attrs(
  ({ color, color2, size, opacity, theme }) => ({
    color: color ?? theme.colors.primary,
    color2: color2 ?? color ?? theme.colors.secondary,
    size: size ?? theme.icons.sizes.standard,
    opacity: opacity ?? 1,
  })
)``
